import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 28px;
  padding-top: 28px;
  border-top: solid 1px #4b4e53;

  input {
    text-align: left;
    padding: 16px 8px;
  }

  span:first-child {
    margin-bottom: 8px;
  }
`;
